import React, { useState } from 'react';
import { CheckCircle, Circle } from 'lucide-react';
import { Card } from './ui/Card';
interface ChecklistProps {
  title: string;
  items: string[];
  id: string;
}
export function Checklist({
  title,
  items,
  id
}: ChecklistProps) {
  const [checkedItems, setCheckedItems] = useState<boolean[]>(new Array(items.length).fill(false));
  const toggleItem = (index: number) => {
    const newChecked = [...checkedItems];
    newChecked[index] = !newChecked[index];
    setCheckedItems(newChecked);
  };
  const completedCount = checkedItems.filter(Boolean).length;
  const progress = Math.round(completedCount / items.length * 100);
  return <Card glass className="p-4 sm:p-6 border-cyan-500/10" data-id="element-107">
      {/* Header - Mobile Optimized */}
      <div className="flex items-center justify-between mb-2 gap-2" data-id="element-108">
        <h3 className="text-base sm:text-xl font-bold text-slate-100 font-mono flex-1 min-w-0" data-id="element-109">
          {title}
        </h3>
        <div className="flex items-center space-x-2 flex-shrink-0" data-id="element-110">
          <span className="text-xs text-slate-500 font-sans whitespace-nowrap" data-id="element-111">
            {completedCount}/{items.length}
          </span>
          <span className="text-sm font-mono text-cyan-400 whitespace-nowrap" data-id="element-112">
            {progress}%
          </span>
        </div>
      </div>

      {/* Progress Bar - Mobile Friendly */}
      <div className="w-full bg-slate-800/50 h-1.5 rounded-full mb-4 sm:mb-6 overflow-hidden relative" data-id="element-113">
        <div className="bg-gradient-to-r from-cyan-500 to-cyan-400 h-full transition-all duration-500 ease-out shadow-[0_0_8px_rgba(6,182,212,0.5)]" style={{
        width: `${progress}%`
      }} data-id="element-114" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" style={{
        width: `${progress}%`
      }} data-id="element-115" />
      </div>

      {/* Checklist Items - Mobile Optimized */}
      <ul className="space-y-2 sm:space-y-3" data-id="element-116">
        {items.map((item, index) => <li key={index} className="flex items-start group cursor-pointer touch-manipulation" onClick={() => toggleItem(index)} data-id="element-117">
            <button className="mt-0.5 mr-2 sm:mr-3 flex-shrink-0 text-slate-500 group-hover:text-cyan-400 transition-colors focus:outline-none min-w-[20px] min-h-[20px] flex items-center justify-center" aria-label={checkedItems[index] ? 'Mark as incomplete' : 'Mark as complete'} data-id="element-118">
              {checkedItems[index] ? <CheckCircle className="h-5 w-5 text-cyan-500 drop-shadow-[0_0_4px_rgba(6,182,212,0.5)]" data-id="element-119" /> : <Circle className="h-5 w-5" data-id="element-120" />}
            </button>
            <span className={`text-xs sm:text-sm transition-colors font-sans break-words ${checkedItems[index] ? 'text-slate-500 line-through decoration-slate-600' : 'text-slate-300 group-hover:text-slate-200'}`} data-id="element-121">
              {item}
            </span>
          </li>)}
      </ul>
    </Card>;
}